import { faBarsFilter } from "@fortawesome/pro-regular-svg-icons/faBarsFilter";
import * as React from "react";

import { MprcIconFa, MprcIconFaProps } from "../MprcIconFa";

export const IconFilter: React.FC<Omit<MprcIconFaProps, "icon">> = (props) => {
    return <MprcIconFa {...props} icon={faBarsFilter} />;
};
